// Feature toggles en variables

const passphrase = "works on my machine";
const productionHosts = ["devconf.nl","www.devconf.nl"];
var prod = {
  "programma" : 2023,
  "event"     : undefined, // /virtual-venue
  "registratie" : undefined,//https://platform.devconf.nl/conference/signup",
  "open_date" : "2023-03-29T09:00",
  "registerLocation" : "",
  "announcement" : "Tot volgend jaar!"
};

var dev = {
  "programma" : 2023,
  "open_date" : "2023-03-29T09:00",
  "registratie" : undefined
};

function get(key){
  if (productionHosts.includes(window.location.hostname) || !(key in dev)){
    return prod[key];
  } else {
    return dev[key];
  }
}

export default {
   getVariable: (key) => { return get(key)},
   isAccessible: () => {
     if (productionHosts.includes(window.location.hostname)){
       return true;
     } else {
       return localStorage.granted ? true: false;
     }
   },
   checkPassphrase: (phrase) => {
     if (phrase == passphrase){
       localStorage.granted = true;
       return true;
     } else {
       return false;
     }
   }
}
